<template>
  <div
      class="global-alert text-xs"
      :class="{ show: alert != null && !forceHide, 'show-max': maximize }"
  >
    <div class="alert-inner">
      <div class="alert-mini" @click="handleMaximize">
        <i class="fa fa-times" @click.stop="hide"></i>
        <div class="left-item alert-type">
          <i
              v-if="getIconAccessory!=null"
              class="d-flex align-items-center justify-content-center"
              v-html="getIconAccessory">
          </i>
          <i v-else :class="alert.event_type_icon"></i>
        </div>
        <div class="infos">
          <span>
            <strong>
              <span class="upper">{{ alert.event_type_label }}</span>
              {{ $t("global.alert.triggered") }} {{ formatDate }}
            </strong>
            <span v-if="alert.identification_name">
              {{ $t("global.by") }} {{ alert.identification_name }} ({{
                alert.dati_name
              }})
            </span>
            <span v-if="!alert.identification_name">
              {{ $t("global.alert.byDevice") }} {{ alert.dati_name }}
            </span>
            <br/>
            <strong>N° {{ alertNumber }}</strong>
          </span>
        </div>
      </div>
      <div class="alert-maxi">
        <i class="fa fa-times" @click="handleMinimize"></i>
        <iframe :src="getUrl"></iframe
        ><!--
                -->
        <Btn
            class="block success"
            v-can="'beepiz-edit-alerts'"
            v-html="$t('alerts.btns.ack')"
            @click.native.stop="dismissAlert"
        ></Btn
        ><!--
            -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Btn from "@/components/ui/Button";
import axios from "axios";
import API from "@/services/API.js";
import Auth from "@/services/auth.js";
import Utils from "@/services/utils.js";
import {getChatUrl} from "./getChatUrl";

import iconIcatSrc from '@/assets/img/iconIcat.svg';

export default {
  name: "alert",
  components: {
    Btn,
  },
  data() {
    return {
      maximize: false,
      forceHide: false,
    };
  },
  props: {
    alert: {
      type: Object,
      default: null,
    },
  },
  computed: {
    iconIcat() {
      return iconIcatSrc
    },
    alertNumber() {
      if (this.alert != null) {
        return Utils.alertNumberFormated(this.alert.id);
      }
      return "";
    },

    getIconAccessory() {
      if (this.alert != null) {
        return Utils.getIconAccessory(this.alert.event_type_icon);
      }
      return null;
    },
    getUrl: function () {
      if (this.alert != null && this.maximize) {
        return this.getChatUrl({
          url: this.alert.url,
          Auth,
          window,
        });
      }
      return null;
    },
    formatDate: function () {
      if (this.alert != null) {
        return moment
            .tz(this.alert.event_at.date, this.alert.event_at.timezone)
            .local()
            .format(Utils.t("datetime.date") + " (HH:mm)");
      }
      return alert;
    },
  },
  methods: {
    getChatUrl,
    handleMaximize: function () {
      this.$emit("maximize", this.alert);
      if (Utils.can("beepiz-select-alerts")) {
        this.maximize = true;
      }
    },
    handleMinimize: function () {
      this.maximize = false;
    },
    hide: function () {
      this.$emit("hide", this.alert);
      this.forceHide = true;
      window.V.$localStorage.set(
          "BPZ_" + Auth.getHash() + "_HIDE_ALERT_" + this.alert.id,
          "1"
      );
    },
    dismissAlert() {
      //console.log(window.Vfc);
      window.Vfc.modalProps = {
        width: "600px",
        height: "260px",
      };
      window.Vfc.$refs.confirm.show({
        title: Utils.t("global.alert.ackConfirmTitle"),
        content: Utils.t("global.alert.ackConfirmContent"),
        zIndex: 10001,
        callbackYes: () => {
          axios
              .put(API.route(API.endpoints.alerts.dismiss, {id: this.alert.id}))
              .then((response) => {
                this.forceHide = true;
                this.maximize = false;
                this.$emit("dismiss", this.alert);
              });
        },
      });
    },
  },
  watch: {
    alert: function () {
      this.forceHide = false;
    },
  },
};
</script>
